import {
  getClientAccountDashboardUrl,
  getClientAccountLabel,
} from "@/lib/clientAccountDashboard";

// Standalone Client Account workspace.
//
// The dashboard is served by the Render backend and embedded here. This page exists so the
// /admin-lacw-client-account and /admin-vals-client-account routes do not have to mount
// StandAloneGuidelines, which is a ~3,000 line component carrying every other portal tool.
//
// Access is enforced by the route name, not by this component. getRequestedPortal() in
// portalAccess.js reads the "admin-" prefix off the path, and AuthenticatedApp refuses the
// render if the signed-in user cannot access that portal. Renaming these routes to drop the
// "admin-" prefix would silently widen access - "/vals-client-account" would resolve to the
// vals portal and let any VALS user in.
export default function ClientAccountDashboard({ clientId }) {
  const label = getClientAccountLabel(clientId);

  return (
    <div className="h-[calc(100dvh-64px)] min-h-0 overflow-hidden bg-slate-50 p-3 sm:p-6">
      <div
        style={{ width: "100%", height: "100%", minHeight: 0, background: "#fff" }}
        className="overflow-hidden rounded-2xl border border-slate-200 shadow-sm"
      >
        <iframe
          src={getClientAccountDashboardUrl(clientId)}
          title={label}
          style={{ display: "block", width: "100%", height: "100%", border: "none" }}
          allow="clipboard-write"
        />
      </div>
    </div>
  );
}
